import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type VariantListClasses = 'label' | 'tab' | 'tabs';

const variantCategoryTabsStyles = makeStyles<ISpcTheme, VariantListClasses>(
  theme => ({
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontMD,
    },
    tab: {
      minWidth: '100px',
      paddingBottom: '0px',
    },
    tabs: {
      borderBottom: `1px solid ${theme.palette.primaryDisabled.main}`,
    },
  }),
  { name: 'Customise_VariantSelector_VariantCategoryTabs' },
);

export default variantCategoryTabsStyles;
